import * as z from 'zod';

export const virtualBackgroundTypeSchema = z.enum(['blur', 'image', 'video']);

export const virtualBackgroundItemSchema = z.object({
  id: z.string(),
  type: virtualBackgroundTypeSchema,
  value: z.string(),
  thumbnail: z.url().optional(),
  label: z.string().optional(),
  isCustom: z.boolean().optional(),
  persisted: z.boolean().optional(),
});

export const virtualBackgroundItemsSchema = z.array(virtualBackgroundItemSchema);
